import React from 'react';
import { Box, Stack } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { formatStringToNumber } from 'utils/formatters';
import { InputField, SelectField } from 'components/form';
import { EquipmentOptionsBlurb } from 'modules/inventoryOptions';
import { EquipmentFormValue } from '../../../../types';
import { FieldsContainer } from '../../../components/FieldsContainer';
import { equipmentConditions, inventoryItemStatuses } from '../../../../constants';
import { EQUIPMENT_CLASS } from '@trnsact/business-criteria';
import { StandardInfoSingle } from '../../../standartInfo';

const equipmentClassOptions = Object.values(EQUIPMENT_CLASS).map(option => ({
  label: option,
  value: option,
}));

interface Props {
  equipmentId?: string;
}

export const CommonInfo = ({ equipmentId }: Props) => {
  const { control } = useFormContext<EquipmentFormValue>();

  const year = useWatch({ control, name: 'year' });
  const make = useWatch({ control, name: 'make' });
  const model = useWatch({ control, name: 'model' });

  return (
    <FieldsContainer columns={5}>
      <Stack direction="row" gap="1rem">
        <Box sx={{ flex: 1 }}>
          <InputField
            label="Quantity"
            control={control}
            name="commonInfo.quantity"
            formatter={formatStringToNumber}
            inputProps={{
              type: 'number',
              required: true,
              variant: 'outlined',
            }}
          />
        </Box>

        <Box sx={{ flex: 1 }}>
          <SelectField
            label="Condition"
            control={control}
            variant="outlined"
            name="commonInfo.condition"
            options={equipmentConditions}
          />
        </Box>
      </Stack>

      <StandardInfoSingle />

      <InputField label="Base Model" name="modelBase" control={control} inputProps={{ variant: 'outlined' }} />

      <InputField label="Serial/VIN#" name="commonInfo.vin" control={control} inputProps={{ variant: 'outlined' }} />

      <InputField label="Stock ID" name="commonInfo.stockId" control={control} inputProps={{ variant: 'outlined' }} />

      <InputField
        label="Mileage"
        control={control}
        name="commonInfo.mileage"
        formatter={formatStringToNumber}
        inputProps={{ type: 'number', variant: 'outlined' }}
      />

      <InputField
        label="Hours"
        control={control}
        name="commonInfo.hours"
        formatter={formatStringToNumber}
        inputProps={{ type: 'number', variant: 'outlined' }}
      />

      <SelectField
        label="Class"
        control={control}
        variant="outlined"
        name="commonInfo.class"
        options={equipmentClassOptions}
      />

      <SelectField
        label="Status"
        control={control}
        variant="outlined"
        name="commonInfo.inventoryItem.status"
        options={inventoryItemStatuses}
      />

      <InputField
        control={control}
        label="Description"
        name="commonInfo.description"
        inputProps={{
          minRows: 3,
          multiline: true,
          variant: 'outlined',
          sx: { gridColumn: '1 / 6' },
        }}
      />

      {equipmentId && (
        <Box sx={{ gridColumn: '1 / 6' }}>
          <EquipmentOptionsBlurb year={year} make={make} model={model} />
        </Box>
      )}
    </FieldsContainer>
  );
};
